import { useState, useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Link, useNavigate } from "react-router-dom";
import React from 'react';
import ImageUploading from 'react-images-uploading';
import { t } from '../locales/translate.js';


function Element({ apiCall, user, setAddSuccess }) {

    // 'game_qr' => 'required|string|max:255',
    // 'organ_qr' => 'nullable|string|max:255',
    // 'game_id' => 'required|exists:games,id',
    // 'depot_id' => 'required|nullable|exists:depots,id',
    // 'weight' => 'nullable|integer',
    // 'notes' => 'nullable|string',
    // 'images' => 'nullable|array',

    const [loading, setLoading] = useState(true);
    const [games, setGames] = useState([]);
    const [qrGameShow, setQrGameShow] = useState(false);

    const [qrMessage, setQrMessage] = useState("");
    const [scanningFor, setScanningFor] = useState("game_qr");

    const [gameQr, setGameQr] = useState("");
    const [organQr, setOrganQr] = useState("");
    const [certificate, setCertificate] = useState(false);
    const [phone, setPhone] = useState("");
    const [name, setName] = useState("");
    const [note, setNote] = useState("");
    const [gameType, setGameType] = useState("");

    const [meatReturn, setMeatReturn] = useState(false);

    const navigate = useNavigate();



    const [images, setImages] = React.useState([]);
    //image errors
    const [imageErrors, setImageErrors] = useState([]);
    const maxNumber = 5;
    const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        setImages(imageList);
    };

    useEffect(() => {

        if (games?.length) {
            const config = { fps: 10, qrbox: { width: 400, height: 400 } };
            const html5QrCode = new Html5Qrcode("qrCodeContainer");

            const qrScanerStop = () => {
                if (html5QrCode && html5QrCode.isScanning) {
                    html5QrCode
                        .stop()
                        .then((ignore) => console.log("Scaner stop"))
                        .catch((err) => console.log("Scaner error"));
                }
            };

            const qrCodeSuccess = (decodedText) => {

                // check if decodedText matches existing GameQr or OrganQr which should not be possible
                if (decodedText === gameQr || decodedText === organQr) {
                    setQrMessage(t('QR-koden är scannad tidigare'));
                    return;
                }

                if (!decodedText) {
                    setQrMessage(t('Felaktig QR-kod'));
                    return;
                }

                //check if decodedText matches 00-00-0000
                const regex = /^[0-9]{2}-[0-9]{2}-[0-9]{4}$/;

                if (regex.test(decodedText)) {
                    setQrGameShow(false);
                    qrScanerStop();
                    setQR(decodedText);
                } else {
                    setQrMessage(t('Felaktig QR-kod'));
                }
            
            };

            if (qrGameShow) {
                html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccess);
                setQrMessage("");
            } else {
                qrScanerStop();
            }

            return () => {
                qrScanerStop();
            };
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qrGameShow]);

    const setQR = (QR) => {
        if (scanningFor) {
            if (scanningFor === "game_qr") {
                setGameQr(QR);
            } else if (scanningFor === "organ_qr") {
                setOrganQr(QR);
            }
        }
    }

    useEffect(() => {

        //if user is logged in set name and phone if they are present in account data
        if (user) {
            setName(user.name || "");
            setPhone(user.phone || "");
            //certificate
            setCertificate(user.certificate || false);
        }

        const fetchGames = async () => {
            try {
                // Request data from get 'games' 
                const response = await apiCall("GET", "games");
                // Handle the response as needed
                //console.log(response.response);
                if (response.error) {
                    throw new Error(response.error);
                }
                setGames(response.response);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        //if  games are not empty, set loading to false
        const fetchData = async () => {
            await Promise.all([fetchGames()]);
            setLoading(false);
        }

        // if game are undefined
        if (!games?.length) {
            fetchData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall]);


    useEffect(() => { 
        if(gameQr.length && gameQr.length > 1 && (iso !== gameQr.slice(0, 2))) {
        const fetchDepot = async () => {
            try {
                // first two letters
                setIso(gameQr.slice(0, 2));
                // Request data from get 'depot' 
                const response = await apiCall("GET", `depot/${gameQr.slice(0, 2)}`);
                // Handle the response as needed
                //console.log(response.response);
                if (response.error) {
                    throw new Error(response.error);
                }

                setSelectedDepot(response.response);
                
            } catch (error) {
                console.log( error.message);
                setSelectedDepot(error.message);
            }
        };
        fetchDepot();
    }

    }, [gameQr]);

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [selectedDepot, setSelectedDepot] = useState("");
    const [iso, setIso] = useState("");

    // useRef is set synchronously, so a second tap before the next render is still blocked
    const submittingRef = useRef(false);
    const [submitting, setSubmitting] = useState(false);

    const submitReport = (e, addmore = false) => {

        e.preventDefault();
        if (submittingRef.current) {
            return;
        }
        setError(null);
        setSuccess(null);

        if (gameQr === organQr) {
            // If game QR and organ QR are the same, show error
            setError(t('game_and_organ_qr_must_be_different'));
            return;
        }

        const data = {
            game_qr: gameQr,
            organ_qr: organQr,
            game_id: gameType,
            phone,
            name,
            notes: note,
            meat_return: meatReturn,
            //images filedata
            images: images.map(image => image.data_url),
            certificate
        };

        if (user?.role_id === 3) {
            // emtpy name and phone for transporter
            data.name = "";
        }

        submittingRef.current = true;
        setSubmitting(true);
        // keep the buttons locked after success when leaving the page, so no tap can slip in before navigation
        let leavingPage = false;

        apiCall("POST", "reports", data)
            .then(({ response, error }) => {
                if (error) {
                    console.error(response);
                    setError(error);
                    return;
                }

                console.log(t('report_added_successfully'), response);
                setSuccess(t('report_added_successfully'));

                // if addmore is true, reset the form
                if (addmore) {
                    setGameQr("");
                    setOrganQr("");
                } else {
                    leavingPage = true;

                    //if user is not logged in redirect to a /login page with React router
                    if (!user?.role_id) {
                        setAddSuccess( response.game_qr );
                        //window.location.href = "/login";
                        navigate("/login");

                        return;
                    }

                    // Redirect to reports list
                    // if user role_id 
                    if (user?.role_id === 3) {
                        window.location.href = "/transport";
                    } else {
                        window.location.href = "/";
                    }
                }
            })
            .catch(err => {
                console.error("Error adding report:", err);
                setError(t('failed_to_add_report'));
            })
            .finally(() => {
                if (!leavingPage) {
                    submittingRef.current = false;
                    setSubmitting(false);
                }
            });

    }

    // Masking function for XX-XX-XXXX
    function formatQrInput(value) {
        // Remove all non-alphanumeric characters
        let v = value.replace(/[^a-zA-Z0-9]/g, '');
        // Limit to 8 chars
        v = v.slice(0, 8);
        // Insert dashes
        if (v.length > 4) {
            return v.slice(0, 2) + '-' + v.slice(2, 4) + '-' + v.slice(4);
        } else if (v.length > 2) {
            return v.slice(0, 2) + '-' + v.slice(2);
        } else {
            return v;
        }
    }

    if (loading) {
        return <div>{t('loading')}</div>;
    }

    return (
        <div className="card create-project-form custom-input">
            <div className="card-body">
                <div className="row">
                    <div className="col-12">
                        <div className="row g-3 needs-validation" noValidate="">

                            <div className="col-md-6">
                                
                                <label className="form-label" htmlFor="projectName">{t('game_qr')}</label>
                                <input className="form-control" id="projectName" type="text" name="game_qr" placeholder={t('game_qr_placeholder')} required value={gameQr} onChange={(e) => setGameQr(formatQrInput(e.target.value))} maxLength={10} />
                                <button className="btn btn-primary button-inset qr-button" type="button" onClick={() => { setScanningFor("game_qr"); setQrGameShow(true); }}>
                                    <i className="fa-solid fa-qrcode"></i> {t('scan_qr')}
                                </button>

                                <span className="selected-depot">{selectedDepot?.name ? <span>Depå: {selectedDepot.name}</span> : <span class="err">{selectedDepot}</span>}</span>

                            </div>

                            {!certificate && (
                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="clientName">{t('organ_qr')}</label>
                                    <input className="form-control" id="clientName" type="text" name="organ_qr" placeholder={t('organ_qr_placeholder')} required value={organQr} onChange={(e) => setOrganQr(formatQrInput(e.target.value))} maxLength={10} />
                                    <button className="btn btn-primary button-inset qr-button" type="button" onClick={() => { setScanningFor("organ_qr"); setQrGameShow(true); }}>
                                        <i className="fa-solid fa-qrcode"></i>{t('scan_qr')}
                                    </button>
                                </div>)}

                            <div className="col-md-6 align-items-center">
                                <div className="form-check form-switch">
                                    <input className="form-check-input" id="certificate" type="checkbox" role="switch" name="certificate" checked={certificate} onChange={(e) => setCertificate(e.target.checked)} />
                                    <label className="form-check-label" htmlFor="certificate">{t('certificate_is_available')}</label>
                                </div>
                            </div>

                            {user?.role_id !== 3 && (<div className="col-md-6">
                                <label className="form-label" htmlFor="projectName">{t('hunter_name')}</label>
                                <input className="form-control" id="projectName" type="text" name="name" placeholder={t('enter_your_name')} required value={name} onChange={(e) => setName(e.target.value)} disabled={!!user?.id} />
                                <div className="invalid-feedback">{t('please_enter_your_name')}</div>
                            </div>)}

                            <div className={`col-md-6 ${user?.role_id === 3 ? 'd-none' : ''}`}>
                                <label className="form-label" htmlFor="clientPhone">{t('hunter_phone')}</label>
                                <input className="form-control" id="clientPhone" type="tel" name="phone" placeholder={t('enter_your_phone')} required value={phone} onChange={(e) => setPhone(e.target.value)} disabled={!!user?.id} />
                                <div className="invalid-feedback">{t('please_enter_your_phone')}</div>
                            </div>

                            <div className="col-lg-12 col-md-12">
                                <label className="form-label" htmlFor="projectType">{t('game_type')}</label>
                                <select className="form-select" id="projectType" required value={gameType} onChange={(e) => setGameType(e.target.value)}>
                                    <option selected disabled value="">{t('choose')}</option>
                                    {games && games.length && games.map((game) => (
                                        <option key={game.id} value={game.id}>{game.name}</option>
                                    ))}
                                </select>
                            </div>

                            {user?.interested_in_meat_return > 0 && selectedDepot && selectedDepot.id && selectedDepot.independent !== 1 && (
                                <div className="col-md-6 d-flex align-items-center">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" id="meatReturn" type="checkbox" role="switch" name="meat_return" checked={meatReturn} onChange={(e) => setMeatReturn(e.target.checked)} />
                                        <label className="form-check-label" htmlFor="meatReturn">{t('meat_return')}</label>
                                    </div>
                                </div>
                            )}


                            {user?.role_id === 3 && (
                                <>
                                    <div className="col-12">
                                        <label className="form-label" htmlFor="validationTextarea">{t('note')}</label>
                                        <textarea className="form-control" id="validationTextarea" placeholder={t('enter_project_details')} required rows="4" name="note" value={note} onChange={(e) => setNote(e.target.value)}>

                                        </textarea>
                                        <div className="invalid-feedback">{t('please_enter_project_details')}</div>
                                    </div>

                                    <ImageUploading
                                        multiple
                                        value={images}
                                        onChange={onChange}
                                        maxFileSize={25 * 1024 * 1024} // 25MB
                                        onError={(errors) => setImageErrors(errors)}
                                        maxNumber={maxNumber}
                                        inputProps={{ capture: "environment" }}
                                        dataURLKey="data_url"
                                        acceptType={["jpg", "png", "jpeg"]}
                                    >
                                        {({
                                            imageList,
                                            onImageUpload,
                                            onImageRemoveAll,
                                            onImageUpdate,
                                            onImageRemove,
                                            isDragging,
                                            dragProps
                                        }) => (
                                            // write your building UI
                                            <div className="upload__image-wrapper">
                                                <div className="buttons">
                                                    <button className="btn btn-secondary"
                                                        style={isDragging ? { color: "red" } : null}
                                                        onClick={onImageUpload}
                                                        {...dragProps}
                                                    >
                                                        <i className="fa fa-camera"></i> {t('click_or_drop_here')}
                                                    </button>

                                                    {images && images.length > 0 && (<button className="btn btn-secondary" onClick={onImageRemoveAll}>{t('remove_all_images')}</button>)}
                                                </div>

                                                <div className="photos">
                                                    {imageList.map((image, index) => (
                                                        <div key={index} className="image-item" style={{ backgroundImage: `url(${image.data_url})` }}>
                                                            <button onClick={() => onImageUpdate(index)}>{t('update')}</button>
                                                            <button onClick={() => onImageRemove(index)}>{t('remove')}</button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </ImageUploading></>)}

                            {imageErrors && (
                                <div>
                                    {imageErrors.maxNumber && <span className="alert alert-danger">{t('number_of_selected_images_exceed_maxNumber')}</span>}
                                    {imageErrors.acceptType && <span className="alert alert-danger">{t('your_selected_file_type_is_not_allow')}</span>}
                                    {imageErrors.maxFileSize && <span className="alert alert-danger">{t('selected_file_size_exceed_maxFileSize')}</span>}
                                    {imageErrors.resolution && <span className="alert alert-danger">{t('selected_file_is_not_match_your_desired_resolution')}</span>}
                                </div>
                            )}


                            {error && <div className="alert alert-danger">{error}</div>}
                            {success && <div className="alert alert-success">{success}</div>}

                            <div className="col-12">
                                <div className="common-flex justify-content-end">
                                    <button className="btn btn-primary" type="submit" onClick={submitReport} disabled={submitting}>{submitting ? t('submitting') : t('add')}</button>
                                    <button className="btn btn-primary" type="submit" onClick={e => submitReport(e, true)} disabled={submitting}>{t('add_and_add_more')}</button>
                                    {user?.role_id !== 3 ? (
                                    <Link to="/" className="btn btn-secondary" type="button">{t('cancel')}</Link>
                                    ) : (
                                        <Link to="/transport" className="btn btn-secondary" type="button">{t('cancel')}</Link>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className={qrGameShow ? ("modal fade show") : ("modal fade")} id="exampleModalfullscreen" tabindex="-1" aria-labelledby="fullScreenModalLabel" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="fullScreenModalLabel">{t('qr_scanner')}</h1>
                            <button className="btn-close py-0" type="button" data-bs-dismiss="modal"
                                aria-label="Close" onClick={() => setQrGameShow(false)}></button>
                        </div>

                        <div className="modal-body dark-modal">
                            <div className="modal-details">
                                <div className="web-content">
                                    <div className="scaner">
                                        <div id="qrCodeContainer" />
                                        {qrMessage && <div className="qr-message">
                                            <p className="text-center scannedtext"><span>{qrMessage}</span></p>
                                        </div>}
                                    </div>

                                </div></div>
                        </div>

                        <div className="modal-footer">
                            {qrMessage && (<>
                                <button className="btn btn-primary"
                                    onClick={() => {
                                        setQrGameShow(false);
                                        setQR(qrMessage);
                                    }} type="button">{t('confirm')}</button>
                            </>)}
                            <button className="btn btn-secondary" type="button" onClick={() => setQrGameShow(false)} data-bs-dismiss="modal">{t('close')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Element;
